module.exports = __webpack_public_path__ + "img/thumb-rinaldho-nurwansyah.a250fa6d.png";